import React, { useState } from 'react';
import axios from 'axios';
import {
  Container,
  Typography,
  TextField,
  Button,
  Paper,
  Box,
  Alert,
  Dialog,
  DialogContent,
  DialogActions
} from '@mui/material';

function App() {
  const [empCode, setEmpCode] = useState('');
  const [seatNumber, setSeatNumber] = useState('');
  const [error, setError] = useState('');
  const [open, setOpen] = useState(false);
  const [alreadyBooked, setAlreadyBooked] = useState(false);

  const handleSubmit = async () => {
    // if (!empCode.trim()) {
    //   setError('Please Enter mobile number');
    //   setSeatNumber('');
    //   setOpen(false);
    //   return;
    // }

   try {
    const res = await axios.post(`../api/getseat`, { empCode });
    // const res = await axios.post(`http://localhost:5000/api/getseat`, { empCode });

    if (res.data.alreadyBooked) {
      setAlreadyBooked(true);
    } else {
      setAlreadyBooked(false);
    }

    setSeatNumber(res.data.seatNumber);
    setError('');
    setOpen(true);
  } catch (err) {
    setSeatNumber('');
    setOpen(false);
    setError(err.response?.data?.error || 'Something went wrong');
  }
};

  const handleClose = () => {
    setOpen(false);
    setEmpCode('');
    setError('');
  };

  return (
    <>
      {/* Logo Section */}
      <Box sx={{ display: 'flex', alignItems: 'center', width: { xs: '250px', sm: '400px' } }}>
        <img
          src={`${process.env.PUBLIC_URL}/logo.png`}
          alt="Logo"
          style={{ width: '100%', height: '100%' }}
        />
      </Box>

      {/* Welcome Text */}
      <Box sx={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: 2,
            width: '100%',
          }}>
        {/* <Typography
          sx={{
            flexGrow: 1,
            textAlign: 'center',
            fontWeight: 600,
            fontSize: { xs: 24, sm: 26 },
            marginTop: 6,
            padding: 2
          }}
        >
          Welcome to Maruti Suzuki<br /> HR Conclave 2025!
        </Typography> */}
        <img
        src={`${process.env.PUBLIC_URL}/app_logo.png`}
        alt="App Logo"
        style={{ width: '100%', height: 'auto' }}
      />
      </Box>

      {/* Form Section */}
      <Container maxWidth="sm">
        <Paper elevation={3} sx={{ padding: 4, marginTop: 3, borderRadius: 4 }}>
          <Typography variant="h6" align="center" gutterBottom>
            Find Your Table
          </Typography>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Mobile Number"
              variant="outlined"
              value={empCode}
              onChange={(e) => {
                setEmpCode(e.target.value);
                setError('');
              }}
              fullWidth
            />
            {/* <Typography variant="10" align="left" gutterBottom>
              Please provide your mobile number without the country code.
            </Typography> */}
            {/* Error Alert */}
            {error && (
              <Alert severity="error" sx={{ marginTop: 3 }}>
                {error}
              </Alert>
            )}
            
            <Button sx={{backgroundColor:"#383387"}} variant="contained" onClick={handleSubmit}>
              Submit
            </Button>
          </Box>

          
        </Paper>
      </Container>

      {/* Success Popup Dialog */}
     <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <Typography>
          {alreadyBooked ? (
            <Alert severity='success'>
              For MSVC 2026 <br/>Your seat number is  <strong>{seatNumber}</strong>
           </Alert>
          ) : (
            <Alert severity='success'>
              {/* Thank you for attending the parts distributor Meet 2025.<br /> */}
              For MSVC 2026 <br/>Your seat number is  <strong>{seatNumber}</strong>
            </Alert>
          )}
        </Typography>
        {/* <Typography
          sx={{
            flexGrow: 1,
            fontSize: { xs: 16, sm: 18 },
            marginTop: 1,
          }}
        >
         HR, Safety & Vigilance Business Conference 2025
        </Typography> */}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="primary">Close</Button>
      </DialogActions>
    </Dialog>

    </>
  );
}

export default App;
